import { render, staticRenderFns } from "./Vuedraggable.vue?vue&type=template&id=21f65eb2&"
import script from "./Vuedraggable.vue?vue&type=script&lang=js&"
export * from "./Vuedraggable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports